import { compose } from 'recompose';
import { connect } from 'react-redux';
import TopUpBalance from './TopUpBalance';
import {changeCountry, getCountries} from "../../../redux/stores/payflow";

export default compose(
  connect(
    state => ({
      payItems: state?.payflow?.payItems || [],
      countries: state?.payflow?.countries || [],
      countryGroups: state?.payflow?.countryGroups || [],

      isLoadingCountries: state?.payflow?.isLoadingCountries || false,
      isLoadingCountryGroups: state?.payflow?.isLoadingCountryGroups || false,
    }),
    dispatch => ({
      getCountries: () => dispatch(getCountries()),
      changeCountry: (country) => dispatch(changeCountry(country)),
    }),
  ),
)(TopUpBalance);
